import "./App.css";
import Delete from "./Delete/Delete";
import Login from "./Login/Login";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/delete" element={<Delete />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
